import React from 'react';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { Inline } from 'web-ui-components/lib/layout/grids';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { UKOnlyPostcodeInput } from 'web-ui-components/lib/data/capture';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from 'prop-types';
import { postCodeFormat, isRequiredAddress } from '../addressUtils/addressUtils';
import { POSTCODE_LIST_ERROR } from '../addressUtils/addressConstants';
import { isValidGlobalBehaviour } from '../../../utils/validation';
import get from 'lodash/get';

const PostCodeComponent = ({
  type,
  onAddManuallyClick,
  onFindAddressClick,
  formValues,
  isAddMunuallyClicked,
  isPostCodeOnly,
  isPostCodeListError,
  postCodeAddressList
}) => (
  <Content>
    {content => (
      <Field name={`${type}.postcode`} subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            inputId="postcode"
            title="Postcode"
            validationMessage={
              !!error || isPostCodeListError
                ? getValidationMessage(content, isPostCodeListError, error, formValues)
                : ''
            }
          >
            <Field
              name={`${type}.postcode`}
              type="input"
              validate={v =>
                isRequiredAddress(
                  v,
                  'postcode',
                  isPostCodeListError,
                  postCodeAddressList,
                  formValues
                )
              }
              parse={postCodeFormat}
            >
              {({ input }) => (
                <Inline.LeftAligned
                  nodes={[
                    <UKOnlyPostcodeInput
                      id={`${type}.postcode`}
                      {...input}
                      value={get(formValues, `${type}.postcode`, '')}
                      onChange={({ value }) => input.onChange(value)}
                    />,
                    <ActionButton.Find
                      labelText={content.findAddress}
                      onClick={e => {
                        e.preventDefault();
                        onFindAddressClick(getName(formValues, type).replace(' ', ''));
                      }}
                    />
                  ]}
                />
              )}
            </Field>

            {isPostCodeOnly && !isAddMunuallyClicked && (
              <NavigationButton.Tertiary
                onClick={e => {
                  e.preventDefault();
                  onAddManuallyClick(true);
                }}
                labelText={content.addManually}
              />
            )}
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

PostCodeComponent.propTypes = {
  onAddManuallyClick: PropTypes.func,
  isAddMunuallyClicked: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  postCodeLabel: PropTypes.string.isRequired
};

const getValidationMessage = (content, isPostCodeListError, error, formValues) => {
  if (isPostCodeListError) {
    return content.postCodeSearchError;
  }
  if (
    formValues &&
    formValues.ukAddress &&
    formValues.ukAddress.postcode &&
    isValidGlobalBehaviour(formValues.ukAddress.postcode, 'postcode')
  ) {
    return content.postCodeListError;
  }
  if (
    formValues.ukAddress &&
    formValues.ukAddress.postcode &&
    !isValidGlobalBehaviour(formValues.ukAddress.postcode, 'postcode')
  ) {
    return content.postCodeError;
  }

  return error === POSTCODE_LIST_ERROR ? content.postCodeSearchError : content.postCodeError;
};

const getName = (formValues, type) =>
  formValues && formValues[type] && formValues[type].postcode ? formValues[type].postcode : '';
export default PostCodeComponent;
